import React, { ReactNode } from 'react';
import { Button } from 'components/Button';
import { Modal } from 'components/Modal';
import styled from 'styled-components';
import { Spinner } from 'react-bootstrap';
import { Loader } from 'components/Table/TableStyles';

type Props = {
  show: boolean;
  onClose: () => void;
  message?: string;
  title: string;
  onConfirm: () => void;
  size?: string;
  confirmLabel?: string;
  isCentered?: boolean;
  testid?: string;
  children?: ReactNode;
  isLoading?: boolean;
  disableSaveButton?: boolean;
};

const MessageContainer = styled.div`
  color: black;
  text-align: justify;
`;

const ConfirmModal: React.FC<Props> = ({
  show,
  onClose,
  message,
  onConfirm,
  title,
  size,
  confirmLabel,
  isCentered,
  children,
  testid,
  isLoading,
  disableSaveButton,
}) => {
  return (
    <Modal
      data-testid={testid}
      show={show}
      onHide={onClose}
      centered={isCentered}
      size={size ?? 'sm'}
    >
      <Modal.Header closeButton={true}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {children ?? <MessageContainer>{message}</MessageContainer>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant='primary'
          onClick={onConfirm}
          disabled={disableSaveButton}
        >
          {isLoading ? (
            <Loader>
              <Spinner size='sm' animation='border' variant='light' />
            </Loader>
          ) : (
            confirmLabel ?? 'Confirm'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;
